<template>
	<div class="talent-service">
		<!-- 统计概览条 -->
		<section class="stats-bar">
			<div class="stat-item" v-for="(s, i) in statItems" :key="i"
				:class="{ 'stat-clickable': s.label === '入库师傅' }"
				:title="s.label === '入库师傅' ? '双击查看全部入库人才' : null" @dblclick="onStatDblclick(s)">
				<div class="icon">{{ s.icon }}</div>
				<div class="num">{{ formatNum(s.num) }}<span class="unit">{{ s.unit }}</span></div>
				<div class="label">{{ s.label }}</div>
				<div class="trend" v-if="!s.links">{{ s.trend }}</div>
				<div class="trend trend-links" v-else>
					<span class="tl-link" v-for="(lk, li) in s.links" :key="li" @click="onStatLink(lk)">{{ lk.text }}</span>
				</div>
			</div>
		</section>

		<!-- 主区 -->
		<main class="main">
			<!-- 左侧：AI人才智能匹配（聊天对话框） -->
			<div class="panel">
				<div class="ai-panel-head">
					<div class="title">AI 人才智能匹配助手</div>
					<div class="ai-online">在线</div>
				</div>

				<div class="ai-hello-bar">
					<div class="ai-avatar">🤖</div>
					<div class="ai-hello-text">
						<div class="name">火锅人才 AI 助手</div>
						<div class="sub">已接入1067名师傅人才库</div>
						 <!-- {{ personCountText }} -->
					</div>
				</div>

				<div class="chat-body" ref="chatBody">
					<div class="chat-msg" :class="m.role" v-for="m in messages" :key="m.id">
						<div class="mini-avatar">{{ m.role === 'ai' ? '🤖' : '👤' }}</div>

						<!-- 纯文本气泡 -->
						<div class="chat-bubble" v-if="m.type === 'text'">
							<div class="hi" v-if="m.hi" v-html="m.hi"></div>
							<div v-for="(line, li) in m.lines" :key="li" v-html="line"></div>
						</div>

						<!-- 职位列表气泡 -->
						<div class="chat-bubble" v-else-if="m.type === 'jobs'">
							<div class="hi" v-html="m.title"></div>
							<div class="bubble-jobs">
								<div class="bubble-job" v-for="j in m.jobs" :key="j.id" @click="showToast('已查看：' + j.name + '（演示）')">
									<div class="bj-left">
										<div class="bj-title">{{ j.name }}<span class="bj-salary">{{ j.salary }}</span></div>
										<div class="bj-meta"><span>{{ j.company }}</span><span>{{ j.city }}</span><span>{{ j.exp }}</span></div>
										<div class="bj-tags">
											<span class="bj-tag" v-for="(t, ti) in j.tags.slice(0, 2)" :key="ti">{{ t }}</span>
											<span class="bj-tag urgent" v-if="j.hot">急招</span>
										</div>
									</div>
									<div class="bj-right">
										<div class="match-ring-sm">
											<svg width="42" height="42">
												<circle cx="21" cy="21" :r="16" fill="none" stroke="rgba(255,255,255,0.08)" stroke-width="3" />
												<circle cx="21" cy="21" :r="16" fill="none" :stroke="ringInfo(j.match).color" stroke-width="3"
													:stroke-dasharray="ringInfo(j.match).circ" :stroke-dashoffset="ringInfo(j.match).offset"
													stroke-linecap="round" />
											</svg>
											<div class="val" :style="{ color: ringInfo(j.match).color }">{{ j.match }}%</div>
										</div>
										<div class="match-label">匹配度</div>
									</div>
								</div>
							</div>
						</div>

						<!-- 加载中气泡 -->
						<div class="chat-bubble" v-else-if="m.type === 'loading'">
							<div class="loading-tip">AI 正在为您匹配最合适的职位…</div>
							<div class="bubble-loading"><span></span><span></span><span></span></div>
						</div>
					</div>
				</div>

				<!-- 聊天输入区 -->
				<div class="chat-input-wrap">
					<textarea ref="aiInput" v-model="aiKeyword" placeholder="告诉我您的招聘或求职需求，例如：招5年以上炒料师傅，擅长牛油锅底，薪资12K起"
						@keydown="onInputKeydown"></textarea>
					<div class="chat-input-foot">
						<span class="chat-tip">Enter 发送 · Shift+Enter 换行</span>
						<button class="chat-send-btn" @click="doMatch">AI 智能匹配 <span class="arr">➤</span></button>
					</div>
				</div>
			</div>

			<!-- 右侧（占2/3） -->
			<div class="right-col">
				<!-- 右上：两列并排 -->
				<div class="right-top">
					<div class="panel">
						<div class="panel-title">
							<span>{{ recruitTitle }}</span>
							<div class="tab-switch">
								<div class="tab-btn" :class="{ active: recruitMode === 'dist' }" @click="switchRecruit('dist')">分布</div>
								<div class="tab-btn" :class="{ active: recruitMode === 'trend' }" @click="switchRecruit('trend')">趋势</div>
							</div>
						</div>
						<div id="pieChart" ref="pieChart" class="chart-box" v-show="recruitMode === 'dist'"></div>
						<div id="trendBarChart" ref="trendBarChart" class="chart-box" v-show="recruitMode === 'trend'"></div>
					</div>

					<div class="panel">
						<div class="panel-title"><span>{{ trainCfg.title }}</span></div>
						<div ref="trainChart" class="chart-box"></div>
					</div>
				</div>

				<!-- 右下：两列并排 -->
				<div class="right-bottom">
					<div class="panel">
						<div class="panel-title">
							<span>证书全国联网查询</span>
							<!-- <span class="more" @click="showToast('证书查询说明')">说明</span> -->
						</div>
						<div class="cert-query">
							<div class="cert-row">
								<div class="cert-input"><input type="text" v-model.trim="queryNo" placeholder="请输入证书编号或身份证号" @keyup.enter="doQuery" /></div>
								<button class="cert-query-btn" :disabled="certLoading" @click="doQuery">
									{{ certLoading ? '查询中…' : '立即查询' }}
									<!-- 无结果/失败只在按钮上方挂个小提示，不再占版面 -->
									<span class="cert-pop" v-if="certPopText">{{ certPopText }}</span>
								</button>
							</div>
						</div>
						<div ref="certChart" class="chart-box"></div>
					</div>

					<div class="panel">
						<div class="panel-title">
							<span>劳动者维权服务</span>
							<span class="badge">在线中</span>
						</div>
						<div class="rights-stats">
							<div class="rs clickable" @click="openRightsList" title="点击查看今日维权记录明细">
								<div class="v">{{ rightsTodayText }}</div>
								<div class="l">今日受理(件)</div>
							</div>
							<div class="rs"><div class="v green">{{ rightsRateText }}</div><div class="l">调解成功率</div></div>
							<div class="rs"><div class="v orange">{{ rightsAvgText }}</div><div class="l">平均办结</div></div>
						</div>
						<div ref="rightsChart" class="chart-box"></div>
					</div>
				</div>
			</div>
		</main>

		<!-- Toast -->
		<div class="page-toast" :class="{ show: toastVisible }">{{ toastText }}</div>

		<!-- PDF 预览弹窗（展商名录等，页内预览不下载） -->
		<div class="pdf-mask" v-if="pdfVisible" @click.self="closePdf">
			<div class="pdf-dialog">
				<div class="pdf-head">
					<div class="pdf-title">{{ pdfTitle }}</div>
					<div class="rights-close" @click="closePdf">×</div>
				</div>
				<div class="pdf-body">
					<div class="pdf-tip" v-if="pdfLoading">PDF 加载中…</div>
					<iframe v-else-if="pdfUrl" class="pdf-frame" :src="pdfUrl" frameborder="0" allowfullscreen></iframe>
				</div>
			</div>
		</div>

		<!-- 今日维权记录明细弹窗 -->
		<div class="rights-mask" v-if="rightsVisible" @click.self="closeRightsList">
			<div class="rights-dialog">
				<div class="rights-head">
					<div class="rights-title">今日维权记录<span class="rights-count">共 {{ rightsList.length }} 条</span></div>
					<div class="rights-close" @click="closeRightsList">×</div>
				</div>
				<div class="rights-body">
					<div class="rights-tip" v-if="rightsLoading">加载中…</div>
					<div class="rights-tip error" v-else-if="rightsError">维权记录获取失败，请重试<span class="rights-retry" @click="getRightsToday">重新加载</span></div>
					<div class="rights-tip" v-else-if="!rightsList.length">今日暂无维权受理记录</div>
					<table class="rights-table" v-else>
						<thead>
							<tr>
								<th class="col-name">维权人</th>
								<th class="col-type">类型</th>
								<th class="col-time">维权时间</th>
								<th class="col-status">状态</th>
								<th>维权图片</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="r in rightsList" :key="r.id">
								<td class="col-name">{{ r.claimantName || '—' }}</td>
								<td class="col-type">
									<span class="rp-tag" :class="'rp-tag-' + r.type">{{ typeMap[r.type] || r.type || '—' }}</span>
								</td>
								<td class="col-time">{{ r.createTime || '—' }}</td>
								<td class="col-status">
									<span class="rp-st" :class="'rp-st-' + r.status">{{ statusMap[r.status] || r.status || '—' }}</span>
								</td>
								<td>
									<div class="rp-photos" v-if="r.photos && r.photos.length">
										<img class="rp-photo" v-for="(p, pi) in r.photos" :key="pi" :src="p" alt="" @click="openPreview(p)" />
									</div>
									<span v-else>—</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

		<!-- 证书查询结果弹窗 -->
		<div class="rights-mask" v-if="certVisible" @click.self="closeCert">
			<div class="rights-dialog">
				<div class="rights-head">
					<div class="rights-title">证书查询结果<span class="rights-count">共 {{ certList.length }} 条</span></div>
					<div class="rights-close" @click="closeCert">×</div>
				</div>
				<div class="rights-body">
					<div class="cert-item" v-for="c in certList" :key="c.id">
						<div class="cert-info">
							<div class="ci-title">
								{{ c.certName || '职业技能证书' }}
								<span class="ci-level" v-if="c.certLevel">{{ c.certLevel }}</span>
								<span class="ci-st" :class="c.status === 0 ? 'ok' : 'bad'">{{ certStatusMap[c.status] || '状态未知' }}</span>
							</div>
							<div class="cert-grid">
								<div class="cg-item"><span class="k">证书编号</span><span class="v">{{ c.certNo || '—' }}</span></div>
								<div class="cg-item"><span class="k">持证人</span><span class="v">{{ c.holderName || '—' }}</span></div>
								<div class="cg-item"><span class="k">身份证号</span><span class="v">{{ maskIdCard(c.idCard) }}</span></div>
								<div class="cg-item"><span class="k">手机号</span><span class="v">{{ maskMobile(c.mobile) }}</span></div>
								<div class="cg-item"><span class="k">创建时间</span><span class="v">{{ c.createTime || '—' }}</span></div>
								<div class="cg-item"><span class="k">备注</span><span class="v">{{ c.remark || '—' }}</span></div>
							</div>
						</div>
						<img class="cert-thumb" v-if="c.imageUrl" :src="c.imageUrl" alt="" @click="openPreview(c.imageUrl)" />
					</div>
				</div>
			</div>
		</div>

		<!-- 入库师傅人才列表弹窗（双击统计卡打开，/admin-api/talent/certificate/page） -->
		<div class="rights-mask" v-if="talentVisible" @click.self="closeTalents">
			<div class="rights-dialog">
				<div class="rights-head">
					<div class="rights-title">入库人才<span class="rights-count">共 {{ talentTotal }} 人</span></div>
					<div class="rights-close" @click="closeTalents">×</div>
				</div>
				<div class="rights-body">
					<div class="rights-tip" v-if="talentLoading">加载中…</div>
					<div class="rights-tip" v-else-if="!talentList.length">暂无人才数据</div>
					<div class="cert-item" v-for="t in talentList" :key="t.id">
						<div class="cert-info">
							<div class="ci-title">
								{{ t.name || '未命名人才' }}
								<span class="ci-st ok" v-if="t.certName">{{ t.certName }}</span>
							</div>
							<div class="cert-grid">
								<div class="cg-item"><span class="k">姓名</span><span class="v">{{ t.name || '—' }}</span></div>
								<div class="cg-item"><span class="k">身份证号</span><span class="v">{{ t.idCard || '—' }}</span></div>
								<div class="cg-item"><span class="k">手机号</span><span class="v">{{ t.mobile || '—' }}</span></div>
								<div class="cg-item"><span class="k">证书名称</span><span class="v">{{ t.certName || '—' }}</span></div>
								<div class="cg-item"><span class="k">证书等级</span><span class="v">{{ t.certLevel || '—' }}</span></div>
								<div class="cg-item"><span class="k">证书编号</span><span class="v">{{ t.certNo || '—' }}</span></div>
								<div class="cg-item"><span class="k">入库时间</span><span class="v">{{ formatTime(t.createTime) }}</span></div>
								<div class="cg-item" style="display: flex;"><span class="k">证书图片</span><span class="v"><div class="cert-imgs" v-if="t.images && t.images.length">
									<img class="cert-thumb" v-for="(img, ii) in t.images" :key="ii" :src="img" alt="" @click="openPreview(img)" />
								</div></span></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 维权图片预览 -->
		<div class="rp-preview" v-if="previewUrl" @click.self="closePreview">
			<img class="rp-preview-img" :src="previewUrl" alt="" />
			<div class="rp-preview-tip" @click="closePreview">点击空白处关闭</div>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts'

	export default {
		name: 'TalentService',
		data() {
			return {
				// 以下四项为页面数据字典（/admin-api/infra/config/get-value-by-key）的默认值，配置返回后覆盖
				cfgStatItems: [
					{ icon: '💼', num: 3860, unit: '个', label: '在招岗位', trend: '' },
					{ icon: '👥', num: 12860, unit: '人', label: '入库师傅', trend: '' },
					{ icon: '🤖', num: 96.4, unit: '%', label: 'AI匹配率', trend: '+4.2%' },
					{ icon: '📜', num: 1604, unit: '人', label: '证书查询', trend: '' },
					{ icon: '⚖️', num: 146, unit: '件', label: '维权受理', trend: '成功92.3%' },
					{ icon: '🔥', num: 15, unit: '万人次', label: '火博展会', links: [
						{ text: '风采一览', url: 'https://m.alltuu.com/album/3015114704/?from=topic&menu=live' },
						{ text: '2025展商名录', url: 'https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/hotPotV3/%E5%A4%A7%E5%B1%8F/2025%E5%B9%B4%E5%B1%95%E5%95%86%E5%90%8D%E5%BD%95.pdf' },
						{ text: '2026展商名录', url: 'https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/hotPotV3/%E5%A4%A7%E5%B1%8F/2026%20%E5%B1%95%E5%95%86%E5%90%8D%E5%BD%95.pdf' },
					] },
				],
				recruitDist: {
					title: '招聘需求分布',
					data: [
						{ name: '后厨操作', value: 38 },
						{ name: '前厅服务', value: 28 },
						{ name: '管理岗位', value: 15 },
						{ name: '技术研发', value: 10 },
						{ name: '后勤保障', value: 9 },
					],
				},
				recruitTrend: {
					title: '近6月招聘需求趋势',
					months: ['5月', '6月', '7月', '8月', '9月', '10月'],
					series: [
						{ name: '岗位发布数', type: 'bar', data: [2860, 3120, 3480, 3620, 3890, 4120] },
						{ name: '入职人数', type: 'line', data: [1980, 2210, 2560, 2680, 2920, 3180] },
					],
				},
				trainCfg: {
					title: '火锅师傅 & 职业技能培训',
					categories: ['炒料', '刀工', '运营', '食安', '高汤', '店长'],
					series: [
						{ name: '在培人数', type: 'bar', data: [1286, 2340, 892, 1560, 720, 1150] },
						{ name: '完课人数', type: 'line', data: [980, 2050, 680, 1320, 560, 890] },
					],
				},
				// 岗位卡片视图模型，/admin-api/ai/talent/home 返回后覆盖；接口未通时作为展示兜底（其中的 kw 为本地匹配遗留字段，已不再使用）
				jobs: [
					{ id: 1, name: '切配师傅', salary: '6-8K', city: '渝中区', exp: '3年', company: '渝味老火锅', tags: ['刀工', '配菜'], hot: true, kw: ['切菜', '切配', '切', '配菜', '刀工', '墩子'] },
					{ id: 2, name: '炒料师傅', salary: '12-18K', city: '江北区', exp: '5年', company: '巴国经典火锅', tags: ['底料炒制', '牛油锅底'], hot: true, kw: ['炒料', '锅底', '炒', '料', '熬料', '火锅底料', '师傅'] },
					{ id: 3, name: '门店店长', salary: '10-15K', city: '南岸区', exp: '5年', company: '山城火锅连锁', tags: ['门店管理', '团队带教'], hot: true, kw: ['店长', '经理', '管理', '门店'] },
					{ id: 4, name: '前厅服务员', salary: '4.5-6K', city: '全部门店', exp: '不限', company: '多家品牌直招', tags: ['服务', '接待', '点单'], hot: false, kw: ['服务', '服务员', '迎宾', '前厅', '接待'] },
					{ id: 5, name: '菜品研发总监', salary: '20-30K', city: '渝北区', exp: '8年', company: '品牌总部', tags: ['新品研发', '口味调试'], hot: false, kw: ['研发', '菜品', '创新', '总监'] },
					{ id: 6, name: '高汤师傅', salary: '8-12K', city: '南岸区', exp: '5年', company: '老字号火锅', tags: ['高汤熬制', '骨汤'], hot: false, kw: ['调汤', '熬汤', '高汤', '汤', '底汤'] },
				],
				messages: [],
				msgSeq: 0,
				// AI 人才首页统计（/admin-api/ai/talent/home），null 表示接口尚未返回
				personCount: null,
				hireCount: null,
				// 大屏人才总数（/admin-api/talent/certificate/talent-count，按身份证去重的一人数），作为「入库师傅」统计卡首选数据源
				talentTotalCount: null,
				// /home 热门推荐与 /match 智能匹配共用的返回条数上限
				matchTopN: 6,
				aiKeyword: '',
				recruitMode: 'dist',
				queryNo: '',
				// 证书精准查询（/admin-api/talent/certificate/query），查到记录直接弹窗展示全部字段
				certLoading: false,
				certVisible: false,
				certList: [],
				// 未查到/失败时只在按钮上方挂一段短文提示，3 秒自收起
				certPopText: '',
				certPopTimer: null,
				certStatusMap: { 0: '有效', 1: '作废' },
				// 入库师傅人才列表弹窗（/admin-api/talent/certificate/page）
				talentVisible: false,
				talentLoading: false,
				talentList: [],
				talentTotal: 0,
				// 近 6 个月发证量堆叠柱（/admin-api/talent/certificate/statistics），接口未回或结构缺失时用演示数据兜底
				certTrend: {
					months: ['5月', '6月', '7月', '8月', '9月', '10月'],
					series: [
						{ name: '中式烹调师', data: [320, 380, 420, 460, 510, 580] },
						{ name: '餐饮经理人', data: [180, 210, 240, 260, 290, 320] },
						{ name: '食安管理员', data: [140, 160, 180, 200, 230, 260] },
						{ name: '火锅专项证', data: [200, 240, 290, 330, 380, 444] },
					],
				},
				// 证书类型颜色：接口返回多少类型就按顺序取，超出后循环
				certColors: ['#00d4ff', '#165DFF', '#b388ff', '#00ff9d', '#ffb020', '#ff4d6a'],
				toastText: '',
				toastVisible: false,
				toastTimer: null,
				// PDF 页内预览
				pdfVisible: false,
				pdfUrl: '',
				pdfTitle: '',
				pdfLoading: false,
				pdfBlobUrl: '',
				// 今日维权记录（/admin-api/talent/rights-protection/today-list）
				rightsVisible: false,
				rightsLoading: false,
				rightsList: [],
				rightsStats: {
					todayAcceptedCount: null,
					totalCount: null,
					completedCount: null,
					mediationSuccessRate: null,
					avgCompletedDays: null,
					typeStats: [],
				},
				previewUrl: '',
				rightsError: false,
				typeMap: {
					WAGE_ARREARS: '工资拖欠',
					LABOR_DISPUTE: '劳动争议',
				},
				statusMap: {
					PENDING: '待处理',
					PROCESSING: '处理中',
					COMPLETED: '已办结',
				},
				// echarts 实例
				pieChartInst: null,
				trendChartInst: null,
				trainChartInst: null,
				certChartInst: null,
				rightsChartInst: null,
			}
		},
		computed: {
			recruitTitle() {
				return this.recruitMode === 'dist' ? this.recruitDist.title : this.recruitTrend.title
			},
			// 顶部统计条：字典为底，业务接口已返回的指标优先覆盖字典值
			statItems() {
				// 隐藏「本月培训」，维权受理顶替其位，末位为火博展会
				const list = (this.cfgStatItems || []).filter(s => s.label !== '本月培训').map(s => ({ ...s }))
				const pick = label => list.find(s => s.label === label)
				const post = pick('在招岗位')
				if (post && this.hireCount != null) post.num = this.hireCount
				const master = pick('入库师傅')
				// 优先用专用接口 talent-count 返回的人才总数，未回时退回 /home 的 personCount
				if (master) {
					if (this.talentTotalCount != null) master.num = this.talentTotalCount
					else if (this.personCount != null) master.num = this.personCount
				}
				const wq = pick('维权受理')
				if (wq) {
					if (this.rightsStats.totalCount != null) wq.num = this.rightsStats.totalCount
					if (this.rightsStats.mediationSuccessRate != null) wq.trend = '成功' + this.rightsStats.mediationSuccessRate + '%'
				}
				if (!pick('火博展会')) {
					list.push({ icon: '🔥', num: 15, unit: '万人次', label: '火博展会', links: [
						{ text: '风采一览', url: 'https://m.alltuu.com/album/3015114704/?from=topic&menu=live' },
						{ text: '2025展商名录', url: 'https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/hotPotV3/%E5%A4%A7%E5%B1%8F/2025%E5%B9%B4%E5%B1%95%E5%95%86%E5%90%8D%E5%BD%95.pdf' },
						{ text: '2026展商名录', url: 'https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/hotPotV3/%E5%A4%A7%E5%B1%8F/2026%20%E5%B1%95%E5%95%86%E5%90%8D%E5%BD%95.pdf' },
					] })
				}
				return list
			},
			// 人才库/在招岗位数未返回时用“—”占位；人才库数与顶部「入库师傅」保持一致（优先 talent-count，回退 /home 的 personCount）
			personCountText() {
				const v = this.talentTotalCount != null ? this.talentTotalCount : this.personCount
				return v == null ? '—' : this.formatNum(v)
			},
			hireCountText() {
				return this.hireCount == null ? '—' : this.formatNum(this.hireCount)
			},
			// 维权统计未返回时用“—”占位，不展示旧的写死值
			rightsTodayText() {
				return this.rightsStats.todayAcceptedCount == null ? '—' : this.rightsStats.todayAcceptedCount
			},
			rightsRateText() {
				return this.rightsStats.mediationSuccessRate == null ? '—' : this.rightsStats.mediationSuccessRate + '%'
			},
			rightsAvgText() {
				return this.rightsStats.avgCompletedDays == null ? '—' : this.rightsStats.avgCompletedDays + '天'
			},
		},
		created() {
			this.initChat()
			// 页面数据字典（统计条 + 招聘需求 + 培训）
			this.getScreenConfig()
			// 人才库统计 + 热门推荐岗位
			this.getTalentHome()
			// 维权板块统计指标（今日受理明细在点击时再拉）
			this.getRightsStatistics()
			// 证书发证量堆叠柱统计
			this.getCertStatistics()
			// 入库师傅总数（大屏人才总数）
			this.getTalentCount()
		},
		mounted() {
			this.$nextTick(() => {
				this.renderPie()
				this.renderTrain()
				this.renderCert()
				this.renderRights()
				this.scrollChatToBottom()
				// 首屏 rem/px2rem 触发重排后 .chart-box(flex:1) 的最终高度才确定，
				// echarts 需在此后重新校准尺寸，否则 canvas 以偏小的瞬时高度渲染会留底部空白
				setTimeout(() => this.resizeCharts(), 200)
			})
			window.addEventListener('resize', this.resizeCharts)
			// 监听容器尺寸变化（含布局稳定、面板高度变化）自动重绘
			if (typeof ResizeObserver !== 'undefined') {
				this.chartRO = new ResizeObserver(() => this.resizeCharts())
				this.$el && this.chartRO.observe(this.$el)
			}
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.resizeCharts)
			if (this.chartRO) {
				this.chartRO.disconnect()
				this.chartRO = null
			}
			if (this.toastTimer) clearTimeout(this.toastTimer)
			if (this.certPopTimer) clearTimeout(this.certPopTimer)
			;[this.pieChartInst, this.trendChartInst, this.trainChartInst, this.certChartInst, this.rightsChartInst]
				.forEach(c => c && c.dispose())
		},
		methods: {
			formatNum(v) {
				return typeof v === 'number' ? v.toLocaleString() : v
			},
			ringInfo(pct) {
				const r = 16
				const circ = 2 * Math.PI * r
				return {
					circ: circ.toFixed(2),
					offset: (circ * (1 - pct / 100)).toFixed(2),
					color: pct >= 85 ? '#00ff9d' : pct >= 70 ? '#00d4ff' : '#ffb020',
				}
			},
			escapeHtml(s) {
				return String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]))
			},
			scrollChatToBottom() {
				const el = this.$refs.chatBody
				if (el) this.$nextTick(() => { el.scrollTop = el.scrollHeight })
			},
			// 初始化欢迎语 + 默认推荐职位
			initChat() {
				this.messages.push({
					id: ++this.msgSeq,
					role: 'ai',
					type: 'text',
					hi: '你好！我是火锅人才 AI 助手 <span class="emoji">🤖</span>',
					lines: this.welcomeLines(),
					isWelcome: true,
				})
				this.messages.push({
					id: ++this.msgSeq,
					role: 'ai',
					type: 'jobs',
					title: '为您推荐当前 <span class="hl">热门职位</span>：',
					jobs: this.buildDefaultJobs(),
					isDefault: true,
				})
			},
			// 欢迎语文案，统计数到达后由 refreshWelcome 重写
			welcomeLines() {
				//  <span class="hl">${this.personCountText}</span> 
				return [
					`目前已接入1067名师傅人才库和 <span class="hl">${this.hireCountText}</span> 个在招岗位。`,
					'告诉我你想应聘什么岗位，比如「<span class="hl">切菜师傅</span>」，我帮你智能匹配最合适的职位。',
				]
			},
			// 默认推荐取前 3 个热门岗位，matchRate 缺失时回退固定梯度
			buildDefaultJobs() {
				return this.jobs.slice(0, 3).map((j, i) => ({ ...j, match: j.match || [96, 91, 87][i] || 78 }))
			},
			/* ===== 入库师傅总数（大屏人才总数）===== */
			getTalentCount() {
				this.$request2('/admin-api/talent/certificate/talent-count').then(res => {
					// data 为整数，0 也是合法值，仅当缺失/非 0 码时忽略
					if (!res || res.code !== 0 || res.data == null) return
					this.talentTotalCount = res.data
				}).catch(() => { })
			},
			/* ===== AI 人才首页：岗位统计 + 热门推荐 ===== */
			getTalentHome() {
				this.$request2('/admin-api/ai/talent/home', { params: { topN: this.matchTopN } }).then(res => {
					if (!res || res.code !== 0 || !res.data) {
						this.showToast((res && res.msg) || '人才首页数据获取失败')
						return
					}
					const d = res.data
					this.personCount = d.personCount
					this.hireCount = d.hireCount
					const jobs = Array.isArray(d.jobs) ? d.jobs : []
					// 接口没返岗位时保留兜底演示数据，避免推荐位空白
					if (jobs.length) this.jobs = jobs.map(this.mapJobCard)
					this.refreshWelcome()
					this.refreshDefaultJobs()
				}).catch(() => {
					this.showToast('人才首页接口请求失败')
				})
			},
			// JobCard 映射为组件内统一的岗位视图模型，模板与本地匹配逻辑无需改动
			mapJobCard(j) {
				const tags = Array.isArray(j.labels) ? j.labels : []
				return {
					id: j.hireId,
					name: j.position || '未命名岗位',
					salary: j.salaryText || '—',
					city: j.district || '—',
					exp: j.experience || '经验不限',
					company: j.company || '—',
					tags,
					hot: j.isUrgent === 1,
					match: j.matchRate || 0,
				}
			},
			refreshWelcome() {
				const w = this.messages.find(m => m.isWelcome)
				if (w) w.lines = this.welcomeLines()
			},
			refreshDefaultJobs() {
				// 用户已发起过匹配时默认推荐位已被移除，不重新插回
				const d = this.messages.find(m => m.isDefault)
				if (d) d.jobs = this.buildDefaultJobs()
			},
			// Enter 发送、Shift+Enter 换行；输入法合成中的回车不触发
			onInputKeydown(e) {
				if (e.key !== 'Enter' || e.shiftKey) return
				if (e.isComposing || e.keyCode === 229) return
				e.preventDefault()
				this.doMatch()
			},
			// 移除指定气泡（loading 等临时消息）
			removeMsg(id) {
				this.messages = this.messages.filter(m => m.id !== id)
			},
			// 追加一条 AI 纯文本气泡
			pushAiText(lines) {
				this.messages.push({ id: ++this.msgSeq, role: 'ai', type: 'text', lines })
				this.scrollChatToBottom()
			},
			// 未输入需求就点匹配：直接用 /home 已拉到的热门岗位，不再请求匹配接口
			showHotJobs() {
				// 同样标为 isDefault，避免空输入反复按 Enter 时叠加多条热门气泡
				this.messages = this.messages.filter(m => !m.isDefault)
				this.messages.push({
					id: ++this.msgSeq,
					role: 'ai',
					type: 'jobs',
					title: '为您推荐当前 <span class="hl">热门职位</span>：',
					jobs: this.buildDefaultJobs(),
					isDefault: true,
				})
				this.scrollChatToBottom()
			},
			/* ===== AI 智能匹配：求职意向 → 职位卡片 ===== */
			doMatch() {
				const query = (this.aiKeyword || '').trim()
				if (!query) {
					this.showHotJobs()
					return
				}
				this.messages.push({ id: ++this.msgSeq, role: 'user', type: 'text', lines: [this.escapeHtml(query)] })
				this.aiKeyword = ''
				// 加载中
				const loadingId = ++this.msgSeq
				this.messages.push({ id: loadingId, role: 'ai', type: 'loading' })
				this.scrollChatToBottom()

				this.$request2.post('/admin-api/ai/talent/match', {
					query,
					category: 'TALENT',
					topN: this.matchTopN,
				}).then(res => {
					this.removeMsg(loadingId)
					if (!res || res.code !== 0 || !res.data) {
						this.showToast((res && res.msg) || '智能匹配获取失败')
						this.pushAiText(['匹配服务暂时没有返回结果，请稍后再试。'])
						return
					}
					const jobs = (Array.isArray(res.data.jobs) ? res.data.jobs : []).map(this.mapJobCard)
					if (!jobs.length) {
						// 无匹配：保留默认热门推荐，只追加引导文案
						this.pushAiText([
							`没有匹配到与「<span class="hl">${this.escapeHtml(query)}</span>」合适的职位，换个说法试试，比如「<span class="hl">炒料师傅</span>」「<span class="hl">门店店长</span>」。`,
						])
						return
					}
					this.messages = this.messages.filter(m => !m.isDefault)
					this.messages.push({
						id: ++this.msgSeq,
						role: 'ai',
						type: 'jobs',
						title: `根据「<span class="hl">${this.escapeHtml(query)}</span>」为您匹配到 <span class="hl">${jobs.length}</span> 个职位：`,
						jobs,
					})
					this.scrollChatToBottom()
				}).catch(() => {
					this.removeMsg(loadingId)
					this.showToast('智能匹配接口请求失败')
					this.pushAiText(['智能匹配暂时连不上服务，请检查网络后重试。'])
				})
			},
			/* ===== 证书全国联网查询 ===== */
			doQuery() {
				const keyword = (this.queryNo || '').trim()
				// 接口要求 keyword 与 holderName 至少填一个，当前单输入框走编号/身份证号全匹配
				if (!keyword) { this.showCertPop('请输入证书编号或身份证号'); return }
				if (this.certLoading) return
				this.certLoading = true
				this.clearCertPop()
				this.$request2('/admin-api/talent/certificate/query', { params: { keyword } }).then(res => {
					this.certLoading = false
					if (res && res.code === 0) {
						const list = Array.isArray(res.data) ? res.data : []
						this.certList = list
						if (list.length) this.certVisible = true
						else this.showCertPop('未查询到证书记录')
					} else {
						this.certList = []
						this.showCertPop((res && res.msg) || '证书查询失败')
					}
				}).catch(() => {
					this.certLoading = false
					this.certList = []
					this.showCertPop('证书查询接口请求失败')
				})
			},
			closeCert() {
				this.certVisible = false
			},
			showCertPop(text) {
				this.certPopText = text
				if (this.certPopTimer) clearTimeout(this.certPopTimer)
				this.certPopTimer = setTimeout(() => { this.certPopText = '' }, 3000)
			},
			clearCertPop() {
				if (this.certPopTimer) clearTimeout(this.certPopTimer)
				this.certPopTimer = null
				this.certPopText = ''
			},
			// 大屏展示不宜满屏铺开证件号与手机号，弹窗内做部分遮挡
			maskIdCard(v) {
				const s = v ? String(v) : ''
				if (!s) return '—'
				return s.length > 8 ? s.slice(0, 4) + '****' + s.slice(-4) : s
			},
			maskMobile(v) {
				const s = v ? String(v) : ''
				if (!s) return '—'
				return s.length === 11 ? s.slice(0, 3) + '****' + s.slice(-4) : s
			},
			// 入库时间：兼容时间戳 / ISO / 空格分隔字符串，统一格式化为 YYYY-MM-DD HH:mm:ss
			formatTime(v) {
				if (!v) return '—'
				if (typeof v === 'string' && /^\d{4}[-/]\d{2}[-/]\d{2}[ T]\d{2}:\d{2}/.test(v)) {
					const s = v.replace('T', ' ').replace(/\//g, '-').slice(0, 19)
					return s.length === 16 ? s + ':00' : s
				}
				const num = typeof v === 'number' ? v : Number(v)
				const d = isNaN(num) ? new Date(v) : new Date(num)
				if (isNaN(d.getTime())) return String(v)
				const p = n => String(n).padStart(2, '0')
				return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
			},
			/* ===== 入库师傅：双击弹框查看全部人才 ===== */
			onStatDblclick(s) {
				if (s && s.label === '入库师傅') this.openTalentList()
			},
			openTalentList() {
				if (this.talentLoading) return
				this.talentVisible = true
				this.talentLoading = true
				this.talentList = []
				this.talentTotal = 0
				// 大屏展示不分页：取最大页容量（pageSize 上限 100）一次拉全
				this.$request2('/admin-api/talent/certificate/page', { params: { pageNo: 1, pageSize: 100 } }).then(res => {
					if (!res || res.code !== 0 || !res.data) {
						this.showToast((res && res.msg) || '入库人才列表获取失败')
						this.talentLoading = false
						return
					}
					const list = Array.isArray(res.data.list) ? res.data.list : []
					this.talentTotal = res.data.total != null ? res.data.total : list.length
					this.talentList = list.map(this.mapTalentRow)
					this.talentLoading = false
				}).catch(() => {
					this.showToast('入库人才列表请求失败')
					this.talentLoading = false
				})
			},
			// TalentCertificateRespVO → 弹窗行视图模型（idCard/mobile 接口已打码，直接展示）
			mapTalentRow(r) {
				const images = r.imageUrl ? String(r.imageUrl).split(';').map(s => s.trim()).filter(Boolean) : []
				return {
					id: r.id,
					name: r.holderName,
					className: r.className,
					certName: r.certName,
					certLevel: r.certLevel,
					certNo: r.certNo,
					idCard: r.idCard,
					mobile: r.mobile,
					createTime: r.createTime,
					images,
				}
			},
			closeTalents() {
				this.talentVisible = false
			},
			/* ===== 证书发证量统计：近 6 个月各类型堆叠柱 ===== */
			getCertStatistics() {
				this.$request2('/admin-api/talent/certificate/statistics').then(res => {
					if (!res || res.code !== 0 || !res.data) {
						console.warn('证书发证量统计获取失败', res && res.msg)
						return
					}
					const d = res.data
					const months = this.parseList(d.months)
					// values 长度可能跟 months 不一致，按月份数截取；数值不做任何换算，接口给什么显什么
					const series = this.parseList(d.series).map(s => ({
						name: s.name || s.code || '其他',
						data: this.parseList(s.values).slice(0, months.length).map(v => Number(v) || 0),
					})).filter(s => s.data.length)
					if (!months.length || !series.length) {
						console.warn('证书发证量统计结构不完整，沿用演示数据', d)
						return
					}
					this.certTrend = { months, series }
					// 数据到齐后重绘；若此时还未 mounted，由 mounted 那次读取同一份数据
					this.$nextTick(() => this.renderCert())
				}).catch(err => {
					console.warn('证书发证量统计请求失败', err)
				})
			},
			// 接口部分数组字段（months/values）会被序列化成 "[...]" 字符串，统一还原成数组
			parseList(v) {
				if (Array.isArray(v)) return v
				if (typeof v === 'string') {
					try {
						const r = JSON.parse(v)
						return Array.isArray(r) ? r : []
					} catch (e) {
						return []
					}
				}
				return []
			},
			switchRecruit(mode) {
				this.recruitMode = mode
				this.$nextTick(() => {
					if (mode === 'trend') {
						if (!this.trendChartInst && this.$refs.trendBarChart) this.renderTrendBar()
						else this.trendChartInst && this.trendChartInst.resize()
					} else {
						this.pieChartInst && this.pieChartInst.resize()
					}
				})
			},
			showToast(msg) {
				this.toastText = msg
				this.toastVisible = true
				if (this.toastTimer) clearTimeout(this.toastTimer)
				this.toastTimer = setTimeout(() => { this.toastVisible = false }, 1800)
			},
			onStatLink(lk) {
				if (!lk || !lk.url) {
					this.showToast('该名录链接待补充')
					return
				}
				// PDF 走页内预览（blob）；其余（如相册）仍新标签打开
				if (/\.pdf($|\?|#)/i.test(lk.url)) {
					this.previewPdf(lk.url, lk.text || 'PDF 预览')
				} else {
					window.open(lk.url, '_blank')
				}
			},
			// OBS 默认域名会强制 Content-Disposition: attachment，iframe 直链只能下载；
			// 改为 fetch 拉成 blob 再生成 blob: 地址（天然 inline）交给 iframe 渲染。需桶允许本站跨域。
			previewPdf(url, title) {
				this.pdfTitle = title
				this.pdfUrl = ''
				this.pdfLoading = true
				this.pdfVisible = true
				fetch(url).then(resp => {
					if (!resp.ok) throw new Error('HTTP ' + resp.status)
					return resp.blob()
				}).then(blob => {
					this.pdfBlobUrl = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }))
					this.pdfUrl = this.pdfBlobUrl
					this.pdfLoading = false
				}).catch(() => {
					// 跨域/网络失败 → 关闭弹窗并新标签打开兵底
					this.pdfVisible = false
					this.pdfLoading = false
					window.open(url, '_blank')
					this.showToast('预览加载失败（可能是桶未开跨域），已新窗口打开')
				})
			},
			closePdf() {
				this.pdfVisible = false
				this.pdfUrl = ''
				this.pdfLoading = false
				if (this.pdfBlobUrl) {
					URL.revokeObjectURL(this.pdfBlobUrl)
					this.pdfBlobUrl = ''
				}
			},
			/* ===== 页面数据字典：统计概览条 / 招聘需求 / 培训 ===== */
			getScreenConfig() {
				this.$request2('/admin-api/infra/config/get-value-by-key?key=' + encodeURIComponent('产业大脑-能力中心大屏')).then(res => {
					if (!res || res.code !== 0 || !res.data) {
						console.warn('人才服务大屏配置获取失败', res && res.msg)
						return
					}
					let cfg = null
					try {
						cfg = JSON.parse(res.data)
					} catch (e) {
						console.warn('人才服务大屏配置不是合法 JSON', e)
						return
					}
					this.applyScreenCfg(cfg)
				}).catch(err => {
					console.warn('人才服务大屏配置请求失败', err)
				})
			},
			// 配置逐块落地，哪一块缺失或结构不对就保留该块默认数据
			applyScreenCfg(cfg) {
				if (!cfg || typeof cfg !== 'object') return
				const items = cfg.statsBar && cfg.statsBar.items
				if (Array.isArray(items) && items.length) this.cfgStatItems = items

				const rd = cfg.recruitDemand || {}
				const dist = rd.distribution
				if (dist && Array.isArray(dist.data) && dist.data.length) {
					this.recruitDist = { title: dist.title || this.recruitDist.title, data: dist.data }
				}
				const trend = rd.trend
				if (trend && Array.isArray(trend.months) && trend.months.length && Array.isArray(trend.series) && trend.series.length) {
					this.recruitTrend = { title: trend.title || this.recruitTrend.title, months: trend.months, series: trend.series }
				}
				const train = cfg.training
				if (train && Array.isArray(train.categories) && train.categories.length && Array.isArray(train.series) && train.series.length) {
					this.trainCfg = { title: train.title || this.trainCfg.title, categories: train.categories, series: train.series }
				}
				this.$nextTick(() => {
					this.renderPie()
					this.renderTrain()
					// 趋势图切到对应 tab 才建实例，没实例就不重绘（隐藏容器上 init 会拿到 0 尺寸），届时直接读新数据
					if (this.trendChartInst) this.renderTrendBar()
				})
			},
			// ===== 图表 =====
			// 字典 series 数组 -> echarts series：柱/线各用一套风格，由调用方传色
			buildAxisSeries(series, styles) {
				return series.map(s => {
					const type = s.type === 'line' ? 'line' : 'bar'
					return { name: s.name, type, data: s.data || [], ...(styles[type] || {}) }
				})
			},
			renderPie() {
				if (!this.$refs.pieChart) return
				if (!this.pieChartInst) this.pieChartInst = echarts.init(this.$refs.pieChart)
				this.pieChartInst.setOption({
					tooltip: { trigger: 'item', textStyle: { fontSize: 12 } },
					legend: { bottom: 0, textStyle: { color: '#7fa8d9', fontSize: 11 }, itemWidth: 10, itemHeight: 10 },
					color: ['#00d4ff', '#165DFF', '#b388ff', '#00ff9d', '#ffb020'],
					series: [{
						type: 'pie', radius: ['42%', '68%'], center: ['50%', '45%'],
						label: { color: '#e6f4ff', fontSize: 11, formatter: '{b}\n{d}%' },
						labelLine: { lineStyle: { color: 'rgba(0,180,255,0.4)' } },
						itemStyle: { borderColor: '#061226', borderWidth: 2 },
						data: this.recruitDist.data,
					}]
				}, true)
			},
			renderTrendBar() {
				if (!this.$refs.trendBarChart) return
				if (!this.trendChartInst) this.trendChartInst = echarts.init(this.$refs.trendBarChart)
				const t = this.recruitTrend
				this.trendChartInst.setOption({
					tooltip: { trigger: 'axis', textStyle: { fontSize: 12 } },
					legend: { data: t.series.map(s => s.name), textStyle: { color: '#7fa8d9', fontSize: 11 }, top: 0 },
					grid: { left: 45, right: 20, top: 35, bottom: 28 },
					xAxis: { type: 'category', data: t.months, axisLine: { lineStyle: { color: '#2a5a9a' } }, axisLabel: { color: '#7fa8d9', fontSize: 11 } },
					yAxis: { type: 'value', splitLine: { lineStyle: { color: 'rgba(0,180,255,0.1)' } }, axisLabel: { color: '#7fa8d9', fontSize: 11 } },
					series: this.buildAxisSeries(t.series, {
						bar: { barWidth: 20, itemStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#00d4ff' }, { offset: 1, color: '#165DFF' }] }, borderRadius: [4, 4, 0, 0] } },
						line: { smooth: true, lineStyle: { color: '#00ff9d', width: 2.5 }, itemStyle: { color: '#00ff9d' }, areaStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: 'rgba(0,255,157,0.28)' }, { offset: 1, color: 'rgba(0,255,157,0)' }] } } },
					})
				}, true)
			},
			renderTrain() {
				if (!this.$refs.trainChart) return
				if (!this.trainChartInst) this.trainChartInst = echarts.init(this.$refs.trainChart)
				const t = this.trainCfg
				this.trainChartInst.setOption({
					tooltip: { trigger: 'axis', textStyle: { fontSize: 11 } },
					legend: { data: t.series.map(s => s.name), textStyle: { color: '#7fa8d9', fontSize: 10 }, top: 0 },
					grid: { left: 36, right: 10, top: 30, bottom: 38 },
					xAxis: { type: 'category', data: t.categories, axisLine: { lineStyle: { color: '#2a5a9a' } }, axisLabel: { color: '#7fa8d9', fontSize: 10, interval: 0 } },
					yAxis: { type: 'value', splitLine: { lineStyle: { color: 'rgba(0,180,255,0.1)' } }, axisLabel: { color: '#7fa8d9', fontSize: 10 } },
					series: this.buildAxisSeries(t.series, {
						bar: { barWidth: 10, itemStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#b388ff' }, { offset: 1, color: '#7c4dff' }] }, borderRadius: [3, 3, 0, 0] } },
						line: { smooth: true, lineStyle: { color: '#ffb020', width: 2 }, itemStyle: { color: '#ffb020' }, symbol: 'circle', symbolSize: 5 },
					})
				}, true)
			},
			renderCert() {
				if (!this.$refs.certChart) return
				// 接口数据到齐后还要重绘一次，实例只建一次，避免重复 init 告警
				if (!this.certChartInst) this.certChartInst = echarts.init(this.$refs.certChart)
				const t = this.certTrend
				const last = t.series.length - 1
				this.certChartInst.setOption({
					tooltip: { trigger: 'axis', textStyle: { fontSize: 11 } },
					legend: { data: t.series.map(s => s.name), textStyle: { color: '#7fa8d9', fontSize: 10 }, top: 0, itemWidth: 10, itemHeight: 8 },
					grid: { left: 40, right: 10, top: 32, bottom: 20 },
					xAxis: { type: 'category', data: t.months, axisLine: { lineStyle: { color: '#2a5a9a' } }, axisLabel: { color: '#7fa8d9', fontSize: 10 } },
					yAxis: { type: 'value', splitLine: { lineStyle: { color: 'rgba(0,180,255,0.1)' } }, axisLabel: { color: '#7fa8d9', fontSize: 10 } },
					series: t.series.map((s, i) => ({
						name: s.name, type: 'bar', stack: 'total', data: s.data, barWidth: 16,
						itemStyle: Object.assign(
							{ color: this.certColors[i % this.certColors.length] },
							// 只给堆叠顶层加圆角，否则中间层也会出现缺口
							i === last ? { borderRadius: [3, 3, 0, 0] } : {}
						),
					})),
				}, true)
			},
			renderRights() {
				if (!this.$refs.rightsChart) return
				if (!this.rightsChartInst) this.rightsChartInst = echarts.init(this.$refs.rightsChart)
				// 维权类型明细由统计接口驱动，typeName 缺失时回退到前端字典
				const list = this.rightsStats.typeStats || []
				const names = list.map(t => t.typeName || this.typeMap[t.type] || t.type || '其他')
				this.rightsChartInst.setOption({
					title: { show: !names.length, text: '暂无维权受理数据', left: 'center', top: 'middle', textStyle: { color: '#4a7bb0', fontSize: 12, fontWeight: 'normal' } },
					tooltip: { trigger: 'axis', textStyle: { fontSize: 11 } },
					legend: { data: ['受理件数', '办结件数'], textStyle: { color: '#7fa8d9', fontSize: 10 }, top: 0 },
					grid: { left: 40, right: 30, top: 30, bottom: 28 },
					xAxis: { type: 'category', data: names, axisLine: { lineStyle: { color: '#2a5a9a' } }, axisLabel: { color: '#7fa8d9', fontSize: 9, interval: 0 } },
					yAxis: { type: 'value', minInterval: 1, splitLine: { lineStyle: { color: 'rgba(0,180,255,0.1)' } }, axisLabel: { color: '#7fa8d9', fontSize: 10 } },
					series: [
						{ name: '受理件数', type: 'bar', data: list.map(t => t.acceptedCount || 0), barWidth: 14, itemStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#ff4d6a' }, { offset: 1, color: '#b3294e' }] }, borderRadius: [3, 3, 0, 0] } },
						{ name: '办结件数', type: 'line', smooth: true, data: list.map(t => t.completedCount || 0), lineStyle: { color: '#00ff9d', width: 2 }, itemStyle: { color: '#00ff9d' }, symbol: 'circle', symbolSize: 5, areaStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: 'rgba(0,255,157,0.25)' }, { offset: 1, color: 'rgba(0,255,157,0)' }] } } }
					]
				}, true)
			},
			resizeCharts() {
				[this.pieChartInst, this.trendChartInst, this.trainChartInst, this.certChartInst, this.rightsChartInst]
					.forEach(c => c && c.resize())
			},
			/* ===== 劳动者维权服务：统计指标 ===== */
			getRightsStatistics() {
				this.$request2('/admin-api/talent/rights-protection/statistics').then(res => {
					if (!res || res.code !== 0 || !res.data) {
						this.showToast((res && res.msg) || '维权统计获取失败')
						return
					}
					const d = res.data
					this.rightsStats = {
						todayAcceptedCount: d.todayAcceptedCount,
						totalCount: d.totalCount,
						completedCount: d.completedCount,
						mediationSuccessRate: d.mediationSuccessRate,
						avgCompletedDays: d.avgCompletedDays,
						typeStats: Array.isArray(d.typeStats) ? d.typeStats : [],
					}
					// 数据到齐后按 typeStats 重绘；若此时还未 mounted，由 mounted 那次读取同一份数据
					this.$nextTick(() => this.renderRights())
				}).catch(() => {
					this.showToast('维权统计接口请求失败')
				})
			},
			/* ===== 劳动者维权服务：今日受理明细 ===== */
			openRightsList() {
				this.rightsVisible = true
				// 每次打开重新拉取，保证“今日”数据实时
				this.getRightsToday()
			},
			closeRightsList() {
				this.rightsVisible = false
				this.previewUrl = ''
			},
			getRightsToday() {
				this.rightsLoading = true
				this.$request2('/admin-api/talent/rights-protection/today-list').then(res => {
					this.rightsLoading = false
					if (res && res.code === 0) {
						this.rightsList = Array.isArray(res.data) ? res.data : []
						this.rightsError = false
					} else {
						this.rightsList = []
						this.rightsError = true
						this.showToast((res && res.msg) || '维权记录获取失败')
					}
				}).catch(() => {
					this.rightsLoading = false
					this.rightsList = []
					this.rightsError = true
					this.showToast('维权记录接口请求失败')
				})
			},
			openPreview(url) {
				if (!url) return
				this.previewUrl = url
			},
			closePreview() {
				this.previewUrl = ''
			},
		}
	}
</script>

<style scoped lang="scss">
	/* 移植自 HTML 原型的全局盒模型重置（scoped 下限定在本组件根节点内） */
	.talent-service,
	.talent-service *,
	.talent-service *::before,
	.talent-service *::after {
		box-sizing: border-box;
	}

	.talent-service {
		--bg-deep: #061226;
		--bg-card: rgba(13, 42, 89, 0.55);
		--border: rgba(0, 180, 255, 0.25);
		--border-bright: rgba(0, 212, 255, 0.6);
		--primary: #00d4ff;
		--cyan: #00e5ff;
		--text: #e6f4ff;
		--text-dim: #7fa8d9;
		--text-muted: #4a7bb0;
		--green: #00ff9d;
		--orange: #ffb020;
		--red: #ff4d6a;

		position: absolute;
		top: 96px;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 8;
		display: flex;
		flex-direction: column;
		color: var(--text);
		font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
		background:
			radial-gradient(ellipse 80% 50% at 50% -10%, rgba(22, 93, 255, 0.25), transparent),
			radial-gradient(ellipse 60% 40% at 80% 100%, rgba(0, 212, 255, 0.08), transparent);
		overflow: hidden;

		&::before {
			content: '';
			position: absolute;
			inset: 0;
			pointer-events: none;
			z-index: 0;
			background-image:
				linear-gradient(rgba(0, 180, 255, 0.04) 1px, transparent 1px),
				linear-gradient(90deg, rgba(0, 180, 255, 0.04) 1px, transparent 1px);
			background-size: 40px 40px;
		}
	}

	/* ===== 统计概览条 ===== */
	.stats-bar {
		position: relative;
		z-index: 1;
		flex-shrink: 0;
		display: grid;
		grid-template-columns: repeat(6, 1fr);
		gap: 12px;
		padding: 10px 24px 0;

		.stat-item {
			position: relative;
			background: var(--bg-card);
			border: 1px solid var(--border);
			border-radius: 6px;
			padding: 10px 14px;
			overflow: hidden;

			&::before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				width: 3px;
				height: 100%;
				background: linear-gradient(180deg, var(--primary), transparent);
			}

			.icon {
				position: absolute;
				right: 10px;
				top: 50%;
				transform: translateY(-50%);
				width: 32px;
				height: 32px;
				border-radius: 6px;
				background: rgba(0, 180, 255, 0.1);
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 16px;
				color: var(--cyan);
				border: 1px solid var(--border);
			}

			.num {
				font-size: 22px;
				font-weight: 700;
				color: #fff;
				line-height: 1.1;

				.unit {
					font-size: 11px;
					color: var(--text-dim);
					margin-left: 3px;
					font-weight: 400;
				}
			}

			.label {
				font-size: 11px;
				color: var(--text-dim);
				margin-top: 3px;
				letter-spacing: 1px;
			}

			.trend {
				font-size: 10px;
				margin-top: 2px;
				color: var(--green);
			}

			.trend-links {
				display: flex;
				flex-wrap: wrap;
				gap: 2px 8px;
				white-space: normal;
				line-height: 1.4;
			}

			.tl-link {
				color: var(--cyan);
				cursor: pointer;
			}

			.tl-link:hover {
				text-decoration: underline;
			}
		}
	}

	/* ===== 主容器 ===== */
	.main {
		position: relative;
		z-index: 1;
		flex: 1;
		min-height: 0;
		padding: 12px 24px 16px;
		display: grid;
		grid-template-columns: 1fr 2fr;
		gap: 14px;
	}

	.right-col {
		display: grid;
		grid-template-rows: 1fr 1fr;
		gap: 14px;
		min-height: 0;
	}

	.right-top,
	.right-bottom {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 14px;
		min-height: 0;
	}

	.panel {
		background: var(--bg-card);
		border: 1px solid var(--border);
		border-radius: 6px;
		padding: 14px;
		position: relative;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		min-height: 0;

		&::after {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			height: 1px;
			background: linear-gradient(90deg, transparent, var(--primary), transparent);
			opacity: 0.6;
		}
	}

	.panel-title {
		font-size: 14px;
		font-weight: 600;
		color: #fff;
		margin-bottom: 10px;
		padding-left: 10px;
		border-left: 3px solid var(--primary);
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-shrink: 0;

		.more {
			font-size: 11px;
			color: var(--text-muted);
			font-weight: 400;
			cursor: pointer;

			&:hover {
				color: var(--cyan);
			}
		}

		.badge {
			font-size: 11px;
			color: var(--cyan);
			font-weight: 400;
			padding: 2px 8px;
			background: rgba(0, 212, 255, 0.1);
			border: 1px solid var(--border);
			border-radius: 3px;
		}
	}

	/* tab切换 */
	.tab-switch {
		display: flex;
		gap: 4px;
	}

	.tab-btn {
		padding: 3px 12px;
		font-size: 11px;
		cursor: pointer;
		border-radius: 3px;
		background: rgba(6, 20, 50, 0.6);
		color: var(--text-dim);
		border: 1px solid var(--border);
		transition: all .2s;

		&.active {
			color: #fff;
			background: linear-gradient(180deg, #165DFF, #0d3aa8);
			border-color: var(--border-bright);
			box-shadow: 0 0 10px rgba(0, 180, 255, 0.3);
		}
	}

	/* ===== AI 人才匹配 ===== */
	.ai-panel-head {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 6px 10px 10px;
		border-bottom: 1px dashed rgba(0, 180, 255, 0.2);
		margin-bottom: 10px;
		flex-shrink: 0;

		.title {
			font-size: 16px;
			font-weight: 700;
			color: #fff;
			padding-left: 10px;
			border-left: 4px solid var(--primary);
			line-height: 1;
		}

		.ai-online {
			font-size: 12px;
			color: var(--green);
			padding: 3px 10px;
			background: rgba(0, 255, 157, 0.08);
			border: 1px solid rgba(0, 255, 157, 0.3);
			border-radius: 3px;
		}
	}

	.ai-hello-bar {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 2px 4px 10px;
		flex-shrink: 0;

		.ai-avatar {
			width: 44px;
			height: 44px;
			border-radius: 50%;
			flex-shrink: 0;
			background: linear-gradient(135deg, #00e5ff 0%, #165DFF 100%);
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 24px;
			box-shadow: 0 0 14px rgba(0, 212, 255, 0.45);
		}

		.ai-hello-text {
			.name {
				font-size: 17px;
				font-weight: 700;
				color: #fff;
			}

			.sub {
				font-size: 13px;
				color: var(--green);
				margin-top: 3px;

				&::before {
					content: '';
					display: inline-block;
					width: 7px;
					height: 7px;
					border-radius: 50%;
					background: var(--green);
					box-shadow: 0 0 6px var(--green);
					margin-right: 6px;
					vertical-align: middle;
				}
			}
		}
	}

	.chat-body {
		flex: 1;
		min-height: 0;
		overflow-y: auto;
		overflow-x: hidden;
		display: flex;
		flex-direction: column;
		gap: 10px;
		padding: 4px 4px 8px;
		scrollbar-width: thin;
		scrollbar-color: rgba(0, 180, 255, 0.3) transparent;

		&::-webkit-scrollbar {
			width: 4px;
		}

		&::-webkit-scrollbar-thumb {
			background: rgba(0, 180, 255, 0.3);
			border-radius: 2px;
		}
	}

	.chat-msg {
		display: flex;
		gap: 10px;
		align-items: flex-start;

		&.user {
			flex-direction: row-reverse;
		}

		.mini-avatar {
			width: 32px;
			height: 32px;
			border-radius: 50%;
			flex-shrink: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 18px;
		}

		&.ai .mini-avatar {
			background: linear-gradient(135deg, #00e5ff, #165DFF);
			box-shadow: 0 0 10px rgba(0, 212, 255, 0.35);
		}

		&.user .mini-avatar {
			background: linear-gradient(135deg, #b388ff, #7c4dff);
		}
	}

	.chat-bubble {
		max-width: calc(100% - 50px);
		background: linear-gradient(135deg, rgba(13, 42, 89, 0.85), rgba(13, 42, 89, 0.55));
		border: 1px solid var(--border);
		border-radius: 10px;
		padding: 10px 14px;
		color: var(--text);
		font-size: 13px;
		line-height: 1.7;
		position: relative;

		.hi {
			font-size: 14px;
			font-weight: 600;
			color: #fff;
			margin-bottom: 2px;
		}

		.hl {
			color: var(--cyan);
			font-weight: 600;
		}

		.emoji {
			font-size: 16px;
		}

		.loading-tip {
			font-size: 12px;
			color: var(--text-dim);
			margin-bottom: 4px;
		}
	}

	.chat-msg.ai .chat-bubble {
		width: 100%;
		max-width: 100%;
		border-top-left-radius: 2px;
	}

	.chat-msg.user .chat-bubble {
		max-width: 70%;
		background: linear-gradient(135deg, rgba(22, 93, 255, 0.45), rgba(13, 42, 89, 0.55));
		border-color: var(--border-bright);
		border-top-right-radius: 2px;
	}

	/* 气泡里的职位列表 */
	.bubble-jobs {
		display: flex;
		flex-direction: column;
		gap: 8px;
		margin-top: 10px;
	}

	.bubble-job {
		display: grid;
		grid-template-columns: 1fr auto;
		gap: 12px;
		padding: 10px 14px;
		background: rgba(6, 20, 50, 0.55);
		border: 1px solid rgba(0, 180, 255, 0.22);
		border-radius: 6px;
		cursor: pointer;
		transition: all .2s;

		&:hover {
			border-color: var(--border-bright);
			background: rgba(20, 60, 120, 0.6);
			box-shadow: 0 0 10px rgba(0, 212, 255, 0.15);
		}

		.bj-left {
			min-width: 0;
		}

		.bj-title {
			font-size: 14px;
			font-weight: 600;
			color: #fff;
			display: flex;
			gap: 10px;
			align-items: center;
		}

		.bj-salary {
			font-size: 13px;
			font-weight: 700;
			color: var(--orange);
		}

		.bj-meta {
			font-size: 11.5px;
			color: var(--text-dim);
			margin-top: 4px;
			display: flex;
			gap: 12px;
			flex-wrap: wrap;
		}

		.bj-tags {
			margin-top: 5px;
			display: flex;
			gap: 5px;
			flex-wrap: wrap;

			.bj-tag {
				font-size: 10.5px;
				padding: 1px 7px;
				border-radius: 2px;
				background: rgba(0, 180, 255, 0.1);
				color: var(--cyan);
				border: 1px solid rgba(0, 180, 255, 0.2);

				&.urgent {
					background: rgba(255, 77, 106, 0.12);
					color: var(--red);
					border-color: rgba(255, 77, 106, 0.3);
				}
			}
		}

		.bj-right {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			gap: 3px;
			min-width: 54px;
		}

		.match-ring-sm {
			width: 42px;
			height: 42px;
			position: relative;

			svg {
				transform: rotate(-90deg);
			}

			.val {
				position: absolute;
				inset: 0;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 11px;
				font-weight: 700;
			}
		}

		.match-label {
			font-size: 10px;
			color: var(--text-muted);
		}
	}

	.bubble-loading {
		display: flex;
		gap: 4px;
		align-items: center;
		padding: 4px 2px;

		span {
			width: 6px;
			height: 6px;
			border-radius: 50%;
			background: var(--cyan);
			animation: bounce 1.2s infinite ease-in-out;

			&:nth-child(2) {
				animation-delay: .15s;
			}

			&:nth-child(3) {
				animation-delay: .3s;
			}
		}
	}

	@keyframes bounce {

		0%,
		80%,
		100% {
			transform: scale(0.6);
			opacity: .4;
		}

		40% {
			transform: scale(1);
			opacity: 1;
		}
	}

	/* 聊天输入区 */
	.chat-input-wrap {
		flex-shrink: 0;
		margin-top: 8px;
		background: rgba(6, 20, 50, 0.7);
		border: 1px solid var(--border-bright);
		border-radius: 8px;
		padding: 10px;
		box-shadow: inset 0 0 12px rgba(0, 100, 200, 0.12), 0 0 10px rgba(0, 212, 255, 0.15);

		textarea {
			width: 100%;
			min-height: 60px;
			max-height: 90px;
			resize: none;
			background: transparent;
			border: none;
			outline: none;
			color: var(--text);
			font-size: 13px;
			line-height: 1.6;
			font-family: inherit;

			&::placeholder {
				color: var(--text-muted);
				font-size: 12px;
			}
		}
	}

	.chat-input-foot {
		display: flex;
		/* 工具图标（语音/表情/简历）已取消，左侧改为快捷键提示 */
		justify-content: space-between;
		align-items: center;
		margin-top: 6px;
		padding-top: 6px;
		border-top: 1px solid rgba(0, 180, 255, 0.12);
	}

	.chat-tip {
		font-size: 11px;
		color: var(--text-dim);
		letter-spacing: .5px;
	}

	.chat-send-btn {
		padding: 6px 16px;
		border: none;
		border-radius: 5px;
		cursor: pointer;
		background: linear-gradient(180deg, #00d4ff, #165DFF);
		color: #fff;
		font-size: 12.5px;
		font-weight: 600;
		letter-spacing: 1px;
		box-shadow: 0 0 10px rgba(0, 212, 255, 0.35);
		transition: all .2s;
		display: flex;
		align-items: center;
		gap: 5px;

		&:hover {
			box-shadow: 0 0 14px rgba(0, 212, 255, 0.55);
		}

		.arr {
			font-size: 14px;
			line-height: 1;
		}
	}

	/* ===== 图表容器 ===== */
	.chart-box {
		width: 100%;
		flex: 1;
		min-height: 0;
	}

	/* ===== 证书查询 ===== */
	.cert-query {
		padding: 12px;
		background: linear-gradient(180deg, rgba(6, 20, 50, 0.65), rgba(6, 20, 50, 0.45));
		border: 1px solid var(--border);
		border-radius: 6px;
		margin-bottom: 10px;
		flex-shrink: 0;
	}

	.cert-row {
		display: flex;
		gap: 10px;
		align-items: stretch;

		.cert-input {
			flex: 1;
			min-width: 0;
			position: relative;

			input {
				width: 100%;
				height: 42px;
				background: rgba(0, 0, 0, 0.35);
				border: 1px solid rgba(0, 180, 255, 0.3);
				color: var(--text);
				padding: 0 14px;
				border-radius: 4px;
				font-size: 13px;
				outline: none;
				transition: all .2s;

				&::placeholder {
					color: var(--text-muted);
					font-size: 13px;
				}

				&:focus {
					border-color: var(--primary);
					box-shadow: 0 0 10px rgba(0, 212, 255, 0.25);
				}
			}
		}
	}

	.cert-query-btn {
		position: relative;
		height: 42px;
		padding: 0 26px;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		background: linear-gradient(180deg, #00b4ff, #165DFF);
		color: #fff;
		font-size: 14px;
		font-weight: 600;
		letter-spacing: 2px;
		box-shadow: 0 2px 12px rgba(0, 180, 255, 0.35);
		white-space: nowrap;
		flex-shrink: 0;
		transition: all .2s;

		&:hover {
			box-shadow: 0 4px 18px rgba(0, 180, 255, 0.55);
		}

		/* 请求进行中：屏蔽重复点击与 hover 发光 */
		&:disabled {
			opacity: .6;
			cursor: default;
			box-shadow: none;

			&:hover {
				box-shadow: none;
			}
		}
	}

	/* 按钮上方的轻量提示（未输入 / 未查到 / 失败），3 秒自动收起 */
	.cert-pop {
		position: absolute;
		left: 50%;
		bottom: calc(100% + 8px);
		transform: translateX(-50%);
		white-space: nowrap;
		padding: 5px 10px;
		font-size: 11px;
		font-weight: normal;
		letter-spacing: 0;
		line-height: 1.4;
		color: #ffe9cf;
		background: rgba(46, 30, 8, 0.95);
		border: 1px solid rgba(255, 176, 32, 0.45);
		border-radius: 4px;
		box-shadow: 0 4px 14px rgba(0, 0, 0, 0.45);
		z-index: 5;

		&::after {
			content: '';
			position: absolute;
			left: 50%;
			top: 100%;
			margin-left: -4px;
			border: 4px solid transparent;
			border-top-color: rgba(255, 176, 32, 0.45);
		}
	}

	/* 弹窗内的单张证书卡片 */
	.cert-item {
		display: flex;
		align-items: flex-start;
		gap: 14px;
		padding: 12px;
		background: rgba(0, 0, 0, 0.28);
		border: 1px solid rgba(0, 180, 255, 0.18);
		border-radius: 4px;

		& + .cert-item {
			margin-top: 10px;
		}

		.cert-thumb {
			width: 96px;
			height: 120px;
			flex-shrink: 0;
			object-fit: cover;
			border-radius: 3px;
			border: 1px solid var(--border-bright);
			background: rgba(6, 20, 50, 0.6);
			cursor: zoom-in;
		}

		.cert-info {
			flex: 1;
			min-width: 0;
		}

		.ci-title {
			display: flex;
			align-items: center;
			gap: 6px;
			font-size: 14px;
			font-weight: 600;
			color: #fff;
			margin-bottom: 8px;
		}

		.ci-level {
			font-size: 10px;
			font-weight: normal;
			color: var(--cyan);
			border: 1px solid rgba(0, 212, 255, 0.4);
			border-radius: 3px;
			padding: 0 4px;
		}

		.ci-st {
			font-size: 11px;
			font-weight: normal;

			&.ok {
				color: var(--green);
			}

			&.bad {
				color: var(--red);
			}
		}

		.cert-grid {
			display: grid;
			grid-template-columns: repeat(2, minmax(0, 1fr));
			gap: 6px 14px;
		}

		.cg-item {
			font-size: 12px;
			line-height: 1.6;
			word-break: break-all;

			.k {
				color: var(--text-dim);
				margin-right: 6px;
			}

			.v {
				color: var(--text);
			}
		}
	}

	/* 证书图片并入信息网格，占整行且排在入库时间之后 */
	.cert-item .cert-imgs {
		grid-column: 1 / -1;
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		margin-top: 4px;
		flex-shrink: 0;
	}

	/* 入库人才缩略图调小 */
	.cert-item .cert-imgs .cert-thumb {
		width: 56px;
		height: 72px;
	}

	.stat-item.stat-clickable {
		cursor: pointer;
	}

	/* ===== 维权 ===== */
	.rights-stats {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 8px;
		margin-bottom: 10px;
		flex-shrink: 0;
	}

	.rs {
		background: rgba(6, 20, 50, 0.4);
		border: 1px solid var(--border);
		border-radius: 4px;
		padding: 10px 6px;
		text-align: center;

		.v {
			font-size: 20px;
			font-weight: 700;
			color: var(--cyan);
			line-height: 1.1;

			&.green {
				color: var(--green);
			}

			&.orange {
				color: var(--orange);
			}
		}

		.l {
			font-size: 10px;
			color: var(--text-dim);
			margin-top: 4px;
		}
	}

	/* ===== 维权记录弹窗 ===== */
	.rs.clickable {
		cursor: pointer;
		transition: all .2s;

		&:hover {
			background: rgba(6, 20, 50, 0.75);
			border-color: var(--border-bright);
			box-shadow: 0 0 12px rgba(0, 180, 255, 0.35);

			.l {
				color: var(--cyan);
			}
		}
	}

	.pdf-mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(3, 10, 26, 0.72);
		z-index: 320;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 102px 0 0;
		box-sizing: border-box;
	}

	.pdf-dialog {
		width: 82%;
		max-width: 1180px;
		height: 80vh;
		display: flex;
		flex-direction: column;
		background: linear-gradient(180deg, rgba(13, 42, 89, 0.98), rgba(6, 20, 50, 0.98));
		border: 1px solid var(--border-bright);
		border-radius: 6px;
		box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5), 0 0 24px rgba(0, 180, 255, 0.25);
		overflow: hidden;
	}

	.pdf-head {
		flex-shrink: 0;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 12px 16px;
		border-bottom: 1px solid var(--border);
		background: rgba(0, 180, 255, 0.08);
	}

	.pdf-title {
		font-size: 15px;
		font-weight: 600;
		color: #fff;
		padding-left: 10px;
		border-left: 3px solid var(--primary);
	}

	.pdf-body {
		flex: 1;
		min-height: 0;
		position: relative;
		background: #fff;
	}

	.pdf-tip {
		position: absolute;
		top: 50%;
		left: 0;
		width: 100%;
		transform: translateY(-50%);
		text-align: center;
		font-size: 14px;
		color: #4a6a9a;
	}

	.pdf-frame {
		display: block;
		width: 100%;
		height: 100%;
		border: none;
		background: #fff;
	}

	.rights-mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(3, 10, 26, 0.72);
		z-index: 300;
		display: flex;
		align-items: center;
		justify-content: center;
		/* 避开 index.vue 顶栏（99 层级在本页面根节点之上），弹窗居中不与其重叠 */
		padding: 102px 0 0;
		box-sizing: border-box;
	}

	.rights-dialog {
		width: 76%;
		max-width: 1180px;
		max-height: 74vh;
		display: flex;
		flex-direction: column;
		background: linear-gradient(180deg, rgba(13, 42, 89, 0.98), rgba(6, 20, 50, 0.98));
		border: 1px solid var(--border-bright);
		border-radius: 6px;
		box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5), 0 0 24px rgba(0, 180, 255, 0.25);
		overflow: hidden;
	}

	.rights-head {
		flex-shrink: 0;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 12px 16px;
		border-bottom: 1px solid var(--border);
		background: rgba(0, 180, 255, 0.08);
	}

	.rights-title {
		font-size: 15px;
		font-weight: 600;
		color: #fff;
		padding-left: 10px;
		border-left: 3px solid var(--primary);
		display: flex;
		align-items: baseline;
		gap: 10px;

		.rights-count {
			font-size: 11px;
			font-weight: 400;
			color: var(--cyan);
		}
	}

	.rights-close {
		width: 26px;
		height: 26px;
		line-height: 24px;
		text-align: center;
		font-size: 16px;
		color: var(--text-dim);
		border: 1px solid var(--border);
		border-radius: 4px;
		cursor: pointer;
		transition: all .2s;

		&:hover {
			color: #fff;
			border-color: var(--border-bright);
			background: rgba(255, 77, 106, 0.25);
		}
	}

	.rights-body {
		flex: 1;
		min-height: 0;
		overflow-y: auto;
		padding: 4px 16px 14px;
	}

	.rights-tip {
		padding: 44px 0;
		text-align: center;
		font-size: 13px;
		color: var(--text-dim);

		&.error {
			color: var(--orange);
		}

		.rights-retry {
			margin-left: 12px;
			color: var(--cyan);
			cursor: pointer;
			text-decoration: underline;
		}
	}

	.rights-table {
		width: 100%;
		border-collapse: collapse;
		font-size: 12px;

		.col-name {
			width: 14%;
		}

		.col-type {
			width: 16%;
		}

		.col-time {
			width: 22%;
		}

		.col-status {
			width: 16%;
		}

		th {
			position: sticky;
			top: 0;
			z-index: 1;
			padding: 9px 10px;
			text-align: left;
			font-weight: 600;
			color: var(--cyan);
			background: rgba(0, 180, 255, 0.12);
			border-bottom: 1px solid var(--border);
		}

		td {
			padding: 9px 10px;
			color: var(--text);
			border-bottom: 1px solid rgba(0, 180, 255, 0.14);
			vertical-align: middle;
			word-break: break-all;
		}

		tbody tr {
			transition: background .15s;

			&:hover {
				background: rgba(0, 180, 255, 0.07);
			}
		}
	}

	/* 类型 / 状态标签 */
	.rp-tag,
	.rp-st {
		display: inline-block;
		padding: 2px 8px;
		border-radius: 3px;
		font-size: 11px;
		border: 1px solid transparent;
		white-space: nowrap;
	}

	.rp-tag-WAGE_ARREARS {
		color: var(--orange);
		background: rgba(255, 176, 32, 0.12);
		border-color: rgba(255, 176, 32, 0.45);
	}

	.rp-tag-LABOR_DISPUTE {
		color: var(--primary);
		background: rgba(0, 212, 255, 0.12);
		border-color: var(--border-bright);
	}

	.rp-st-PENDING {
		color: var(--red);
		background: rgba(255, 77, 106, 0.12);
		border-color: rgba(255, 77, 106, 0.45);
	}

	.rp-st-PROCESSING {
		color: var(--orange);
		background: rgba(255, 176, 32, 0.12);
		border-color: rgba(255, 176, 32, 0.45);
	}

	.rp-st-COMPLETED {
		color: var(--green);
		background: rgba(0, 255, 157, 0.12);
		border-color: rgba(0, 255, 157, 0.45);
	}

	/* 维权图片 */
	.rp-photos {
		display: flex;
		flex-wrap: wrap;
		gap: 6px;
	}

	.rp-photo {
		width: 38px;
		height: 38px;
		object-fit: cover;
		border-radius: 3px;
		border: 1px solid var(--border);
		cursor: pointer;
		transition: all .2s;

		&:hover {
			border-color: var(--border-bright);
			box-shadow: 0 0 10px rgba(0, 180, 255, 0.45);
		}
	}

	/* 图片大图预览 */
	.rp-preview {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(3, 10, 26, 0.88);
		z-index: 400;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		cursor: zoom-out;

		.rp-preview-img {
			max-width: 80vw;
			max-height: 78vh;
			object-fit: contain;
			border: 1px solid var(--border-bright);
			border-radius: 4px;
			box-shadow: 0 0 30px rgba(0, 180, 255, 0.35);
			cursor: default;
		}

		.rp-preview-tip {
			margin-top: 12px;
			font-size: 12px;
			color: var(--text-dim);
		}
	}

	/* ===== Toast ===== */
	.page-toast {
		position: fixed;
		top: 70px;
		left: 50%;
		transform: translateX(-50%);
		background: rgba(13, 42, 89, 0.95);
		border: 1px solid var(--border-bright);
		color: #fff;
		padding: 9px 18px;
		border-radius: 4px;
		font-size: 12px;
		/* 需高于维权记录弹窗(300)与图片预览(400)，否则弹窗内提示会被遮 */
		z-index: 500;
		opacity: 0;
		transition: opacity .25s;
		box-shadow: 0 4px 20px rgba(0, 180, 255, 0.3);
		pointer-events: none;

		&.show {
			opacity: 1;
		}
	}
</style>
